import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventData} from '../types';

import CheckIcon from '../../../../../assets/icons/check.svg';
import CloseIcon from '../../../../../assets/icons/close.svg';
import {getYcLogoFile} from '../../../../../utils/entity/file';
import {envManager} from '../../../../../utils/env';

export const getData = (event: NotificationEvent): EventData => {
  const data: EventData = {};

  data.avatar = getYcLogoFile(180);
  data.avatarPlaceholder = 'Your Coach';

  data.title =
    /**
     * @i18n_parser
     *
     * t('notifications:coach_video_approved.core.title')
     * t('notifications:coach_video_rejected.core.title')
     * t('notifications:coach_video_approved.b2b.title')
     * t('notifications:coach_video_rejected.b2b.title')
     */
    i18n.t(
      `notifications:${event.type}.${envManager.isB2b ? 'b2b' : 'core'}.title`,
    );

  if (event.type === 'coach_video_approved') {
    data.icon = CheckIcon;
    data.iconGradient = 'success';
  } else {
    data.icon = CloseIcon;
    data.iconGradient = 'danger';
  }

  return data;
};
